import { Button } from "PFComponents/button";
import { Typography } from "PFComponents/typography";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { CustomValueImport } from "PFTypes";
import React from "react";
import { useTranslation } from "react-i18next";

import { ImportModalPage } from "../../constants/import_modal_page";
import { useImportSkillsModalContext } from "../../contexts/import_skills_modal_context";
import css from "./import_data_table_page.module.scss";

type ImportDataTableHeaderProps = {
  importData: CustomValueImport;
};

export const ImportDataTableHeader = ({
  importData: {
    createdAt,
    csvAttachment: { filename }
  }
}: ImportDataTableHeaderProps) => {
  const { setCurrentPage } = useImportSkillsModalContext();
  const { formatLongDate } = useDateFormatter();
  const { t } = useTranslation("skillsManagement", { keyPrefix: "header.modals.import" });

  const goBackToHistory = () => setCurrentPage(ImportModalPage.ImportHistory);

  return (
    <Typography variant="h5" noMargin className={css.header}>
      <Button text={t("importHistory")} kind="text" onClick={goBackToHistory} className={css.headerButton} />
      <span>
        / {formatLongDate(createdAt)} (<em>{filename}</em>)
      </span>
    </Typography>
  );
};
